import { render, staticRenderFns } from "./FontSelector.vue?vue&type=template&id=c01e9878&scoped=true"
import script from "./FontSelector.vue?vue&type=script&lang=js"
export * from "./FontSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c01e9878",
  null
  
)

export default component.exports